module.exports = __webpack_public_path__ + "static/media/me2.b298b350.jpg";